// local lib
import extractFinancialData from './extractFinancialData.lib';

const renderRevenueChart = ({company}) => {
  const {data} = extractFinancialData({company});
  return [...data].some((dataPoint) => !!dataPoint.data.length);
};

export default renderRevenueChart;
